import { getAuth, signInAnonymously } from 'firebase/auth';

/**
 * Ensures the client has a valid Firebase Auth session.
 *
 * AddToQuickTaleContainer uses anonymous auth to satisfy Firebase rules.
 * If the tab sits for a long time, the auth session/token can expire, causing
 * Storage/Firestore/Callable Functions to fail with permission/unauthorized.
 *
 * This helper will:
 *  - sign in anonymously if there is no currentUser
 *  - optionally force-refresh the ID token to avoid stale credentials
 */
export async function ensureFirebaseAuth({ forceRefresh = true } = {}) {
  const auth = getAuth();

  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }

  if (forceRefresh && auth.currentUser) {
    // Force refresh to reduce chances of using an expired token.
    await auth.currentUser.getIdToken(true);
  }

  return auth.currentUser;
}
